import { Table, Text } from '@factorialco/deprecated-design-system'
import { BookkeeperCustomerFragment } from 'generated/resources/graphql'

interface Props {
  customers: BookkeeperCustomerFragment[]
  setSelectedCustomer: (customer: BookkeeperCustomerFragment | null) => void
}

const Body = ({ customers, setSelectedCustomer }: Props) => {
  return (
    <Table.Body>
      {customers.map((customer) => (
        <Table.Row
          key={`bk_customer_${customer.id}`}
          onClick={() => setSelectedCustomer(customer)}
          link
          clickable
        >
          <Table.Cell>
            <Text.Normal weight="normal" size="200">
              {customer.customerCompanyName}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell>
            <Text.Normal weight="normal" size="200">
              {customer.bookkeepersCount}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell>
            <Text.Normal weight="normal" size="200">
              {customer.customerSince}
            </Text.Normal>
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  )
}

export default Body
